import React, { useEffect, useState } from "react";
import "react-tippy/dist/tippy.css";
import "./App.scss";
import "./Common/components/CustomPopup/popup.scss";
import "leaflet/dist/leaflet.css";
import { useQuery } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
// import { useList } from "react-use";
import { useDispatch, useSelector } from "react-redux";
import PrintContextProvider from "react-to-print";
// import Home from "./pages/Home/Home";
// import Comparator from "./pages/Comparator/Comparator";
import { AUTHENTIFICATION_IMPLEMENTATION } from "./Common/utils/constants";
import { _getTokenImplementation } from "./Common/utils/api/api.js";

import {
  fetchSeamless,
  getCartesianFiltersValues,
  getFiltersValues,
  getSavedConfigurationById,
  getSession,
  getTechnologiesScope,
  logEvent,
  saveConfiguration,
  // setDefaultUrl,
  updateConfigurationApi
} from "./Common/utils/api/api";
// import Filters from "./pages/Filters/Filters";
import StartPage from "./Retrofit/pages/StartPage/StartPage";
import EndPage from "./Retrofit/pages/EndPage/EndPage";
import {
  closeMinimalPopup,
  resetRetrofit,
  selectMinimalPopup,
  selectShowReadOnlyDialogPopup,
  setConfiguration,
  setPossibleFiltersValues,
  // setConfigurationStatus,
  setReadOnlyMode,
  setShowReadOnlyDialogPopup,
  selectShowContinueOnDesktopPopup,
  setShowContinueOnDesktopPopup,
  showSnackbar,
  selectShowAxisPopup,
  selectCurrentFiltersStepperStep,
  selectMobileBundleInfoPopup,
  closeMobileBundleInfoPopup,
  setPartnerPreferences,
  selectRetrofitCurrentStep,
  selectRetrofitConfiguration,
  selectPartnerPreferences
} from "./Retrofit/store/slices/retrofit";

import {
  resetCartesian,
  selectCartesianConfiguration,
  selectCartesianCurrentStep,
  selectCartesianShowReadOnlyDialogPopup,
  setCartesianConfiguration,
  setCartesianPossibleFiltersValues,
  setCartesianReadOnlyMode,
  setCartesianShowReadOnlyDialogPopup
} from "./Cartesian/store/slices/cartesian.js";
import {
  resetMc12,
  selectMc12Configuration,
  selectMc12CurrentStep,
  setMc12Configuration
} from "./Mc12/store/slices/mc12";
import Spinner from "./Common/components/Icons/Spinner/Spinner";
import Header from "./Common/layouts/Header/Header";
import t, { loadTranslation } from "./Common/utils/translation/translator";
import ApplicationSettings from "./Retrofit/pages/ApplicationSettings/ApplicationSettings";
import SpecifySelect from "./Retrofit/pages/SpecifySelect/SpecifySelect";
import SelectStep from "./Retrofit/pages/SelectStep/SelectStep";
import Specify from "./Retrofit/pages/Specify/Specify";
import CustomPopup from "./Common/components/CustomPopup/CustomPopup";
import useCheckMobileScreen from "./Common/utils/useCheckMobileScreen";
import MobileBundleInfoPopup from "./Retrofit/components/Devices/MobileBundleInfoPopup";
import { generateDistributorColors, getRGBColor } from "./Common/utils/colors";
import Kinematics from "./Cartesian/pages/Kinematics/Kinematics";
import Mechanics from "./Cartesian/pages/Mechanics/Mechanics";
import Dynamics from "./Cartesian/pages/Dynamics/Dynamics";
import AxisSelection from "./Cartesian/pages/AxisSelection/AxisSelection";
import { getAllSteps } from "./Common/store/utils/utils";
import {
  resetCommon,
  selectConfigurationType,
  selectEventsData,
  selectFullScreen,
  selectLocale,
  selectSessionIdFetched,
  selectShowCancelDialogPopup,
  setSeamlessSessionIdFetched,
  selectSeamlessSessionIdFetched,
  setConfigurationType,
  setFullScreen,
  setIsNewSessionId,
  setLocale,
  setSessionIdFetched,
  setShowCancelDialogPopup,
  updateConfiguration,
  setSeamlessSession,
  setSeamlessSessionWithOkta
} from "./Common/store/slices/common";
import BuildTrack from "./Mc12/pages/BuildTrack/BuildTrack.page";
import ElectricalInstallation from "./Mc12/pages/ElectricalInstallation/ElectricalInstallation.page";
import Communication from "./Mc12/pages/Communication/Communication.page";
import Accessories from "./Mc12/pages/Accessories/Accessories.page";
import FinalizeCartesian from "./Cartesian/pages/Finalize/FinalizeCartesian";
import AxisOptions from "./Cartesian/pages/AxisOptions/AxisOptions";
import Finalize from "./Mc12/pages/Finalize/Finalize.page";
import { useSaveConfiguration } from "./Common/components/StartPage/StartConfigurationUtil";
import { setTechnologiesScope } from "./Common/store/slices/common";
import {
  resetIntegratedDrives,
  selectIntegratedDrivesConfiguration,
  selectIntegratedDrivesCurrentStep,
  setIntegratedDrivesConfiguration,
  setIntegratedDrivesPossibleFiltersValues
} from "./IntegratedDrives/store/slices/integrated_drives";
import SpecifyAndConfigure from "./IntegratedDrives/pages/SpecifyAndConfigure/SpecifyAndConfigure";
import IntegratedDrivesFinalize from "./IntegratedDrives/pages/Finalize/IntegratedDrivesFinalize";

const App = () => {
  const isMobile = useCheckMobileScreen();
  const steps = getAllSteps();
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const cartesianConfiguration = useSelector(selectCartesianConfiguration);
  const mc12Configuration = useSelector(selectMc12Configuration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  // it's important to start with cartesianConfiguration, because we can have a retrofit configuration which is a part of the cartesian configuration
  const configuration =
    cartesianConfiguration || retrofitConfiguration || mc12Configuration || integratedDrivesConfiguration;
  const configurationType = useSelector(selectConfigurationType);
  const retrofitCurrentStep = useSelector(selectRetrofitCurrentStep);
  const cartesianCurrentStep = useSelector(selectCartesianCurrentStep);
  const mc12CurrentStep = useSelector(selectMc12CurrentStep);
  const integratedDrivesCurrentStep = useSelector(selectIntegratedDrivesCurrentStep);

  // Define which currentStep to use
  let currentStep = retrofitCurrentStep;
  if (configurationType === "CARTESIAN") {
    currentStep = cartesianCurrentStep;
  } else if (configurationType === "MC12") {
    currentStep = mc12CurrentStep;
  } else if (configurationType === "INTEGRATED_DRIVES") {
    currentStep = integratedDrivesCurrentStep;
  }

  const dispatch = useDispatch();

  const showReadOnlyDialogPopup =
    configurationType === "CARTESIAN"
      ? useSelector(selectCartesianShowReadOnlyDialogPopup)
      : useSelector(selectShowReadOnlyDialogPopup);
  const showCancelDialogPopup = useSelector(selectShowCancelDialogPopup);
  const mobileBundleInfoPopup = useSelector(selectMobileBundleInfoPopup);

  const eventsData = useSelector(selectEventsData);

  const locale = useSelector(selectLocale);
  const displayCurrentStep = () => {
    switch (currentStep) {
      // retrofit
      case steps.retrofit.APPLICATION_SETTINGS:
        return <ApplicationSettings />;
      case steps.retrofit.SPECIFY_SELECT:
        return <SpecifySelect />;
      case steps.retrofit.SPECIFY:
        return <Specify />;
      case steps.retrofit.SELECT:
        return <SelectStep />;
      // case steps.OVERVIEW:
      //   return <Overview />;
      case steps.retrofit.SAVEANDSHARE:
        return <EndPage />;
      // cartesian
      case steps.cartesian.KINEMATICS:
        return <Kinematics data-testid="kinetics" />;
      case steps.cartesian.MECHANICS:
        return <Mechanics data-testid="mechanics" />;
      case steps.cartesian.DYNAMICS:
        return <Dynamics data-testid="dynamics" />;
      case steps.cartesian.AXIS_SELECTION:
        return <AxisSelection data-testid="axis-selection" />;
      case steps.cartesian.AXIS_OPTIONS:
        return <AxisOptions data-testid="axis-options" />;
      // case steps.cartesian.CARTESIAN_ACCESSORIES:
      //   return <CartesianAccessories data-testid="cartesian-accessories" />;
      case steps.cartesian.FINALIZE_CARTESIAN:
        return <FinalizeCartesian data-testid="finalize-cartesian" />;
      // mc12
      case steps.mc12.BUILD_TRACK:
        return <BuildTrack />;
      case steps.mc12.ELECTRICAL_INSTALLATION:
        return <ElectricalInstallation />;
      case steps.mc12.COMMUNICATION:
        return <Communication />;
      case steps.mc12.ACCESSORIES:
        return <Accessories />;
      case steps.mc12.FINALIZE:
        return <Finalize />;

      // Integrated Drives
      case steps.integratedDrives.SPECIFY_AND_CONFIGURE:
        return <SpecifyAndConfigure />;
      case steps.integratedDrives.FINALIZE:
        return <IntegratedDrivesFinalize />;

      default:
        return <StartPage />;
    }
  };
  const {
    refetch: execDuplicateConfiguration,
    isLoading,
    isFetching
  } = useQuery(
    "Duplicate a read only configuration",
    async () => {
      try {
        // console.log(
        //   "Duplicating read only configuration",
        //   configuration.configId,
        //   configuration.configData
        // );
        // save the configuration with a new name
        const countryScope = window.msizerConfiguration?.locale.split("-")[1] || "WW";
        const savedConf = await saveConfiguration({
          ...configuration.configData,
          country: countryScope,
          configName: `${configuration.configData.configName} copy`,
          configStatus: currentStep.status,
          currentStepId: currentStep.id
        });

        if (configurationType === "CARTESIAN") {
          dispatch(setCartesianConfiguration(savedConf.savedConfigData));
          dispatch(setCartesianShowReadOnlyDialogPopup(false));
          dispatch(setCartesianReadOnlyMode(false));
        } else {
          dispatch(setConfiguration(savedConf.savedConfigData));
          dispatch(setShowReadOnlyDialogPopup(false));
          dispatch(setReadOnlyMode(false));
        }

        return savedConf;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleEditReadOnlyConfiguration = () => {
    // duplicate configuration and save it
    execDuplicateConfiguration();
    logEvent(
      eventsData.locale,
      eventsData.types.duplicateConf,
      eventsData.tags.reopennedConfig,
      configuration?.configId
    );
  };

  const showAxisPopup = useSelector(selectShowAxisPopup);
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);

  const {
    refetch: execCancelConfiguration,
    isFetching: isFetchingCancelConfiguration,
    isLoading: isLoadingCancelConfiguration
  } = useQuery(
    "CANCEL : change status then update it",
    async () => {
      try {
        const id = configuration?.configId;
        if (id) {
          // switch currentStep
          // if currentStep is steps.APPLICATION_SETTINGS then use applicationSettingsStep
          // if currentStep is steps.SPECIFY_SELECT then :
          // if showAxisPopup is false then use specifySelectRecap
          // else if currentFiltersStep === 1 then use specifySelectTable
          // else if currentFiltersStep === 2 then use specifySelectCompare
          // else use none
          const logEventTag = (function logEventTagFn() {
            switch (currentStep) {
              case steps.retrofit.APPLICATION_SETTINGS:
                return eventsData.tags.applicationSettingsStep;
              case steps.retrofit.SPECIFY_SELECT:
                if (showAxisPopup === false) {
                  return eventsData.tags.specifySelectRecap;
                }
                switch (currentFiltersStep) {
                  case 1:
                    return eventsData.tags.specifySelectTable;
                  case 2:
                    return eventsData.tags.specifySelectCompare;
                  default:
                    return eventsData.tags.none;
                }
              default:
                return eventsData.tags.none;
            }
            // eslint-disable-next-line prettier/prettier
          })();

          logEvent(eventsData.locale, eventsData.types.cancelCurrentConf, logEventTag, id);
          const fetchedConf = await getSavedConfigurationById({
            id,
            configurationType
          });
          // console.log("CANCEL : fetchedConf", fetchedConf.configuration);
          fetchedConf.configuration.configData.configStatus = "CANCELLED";
          const updatedConf = await updateConfigurationApi(id, fetchedConf.configuration.configData);
          dispatch(setShowCancelDialogPopup(false));
          // reset application
          switch (configurationType) {
            case "MC12":
              dispatch(resetMc12());
              break;
            case "CARTESIAN":
              dispatch(resetCartesian());
              break;
            case "RETROFIT":
              dispatch(resetRetrofit());
              break;
            case "INTEGRATED_DRIVES":
              dispatch(resetIntegratedDrives());
              break;
            default:
              dispatch(resetRetrofit());
          }
          dispatch(resetCommon());

          return updatedConf;
        }
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleCancelConfiguration = () => {
    execCancelConfiguration();
  };

  const { refetch: execSession } = useQuery(
    "Sessionsn",
    async () => {
      try {
        const session = await getSession();
        dispatch(setSessionIdFetched(true));
        dispatch(setIsNewSessionId(session.sessionStatus === "NEW"));
        return session;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const { refetch: execSeamlessSession } = useQuery(
    "SeamlessSession",
    async () => {
      console.debug(
        "execSeamlessSession:",
        window.msizerConfiguration.seamlessToken,
        window.msizerConfiguration.seamlessEnv,
        window.msizerConfiguration.idpApp
      );
      try {
        if (window.msizerConfiguration.seamlessToken && window.msizerConfiguration.seamlessEnv) {
          let implementation = AUTHENTIFICATION_IMPLEMENTATION.CIAM;
          if (
            window.msizerConfiguration.idpApp === AUTHENTIFICATION_IMPLEMENTATION.OKTA ||
            _getTokenImplementation(window.msizerConfiguration.seamlessToken) === AUTHENTIFICATION_IMPLEMENTATION.OKTA
          ) {
            implementation = AUTHENTIFICATION_IMPLEMENTATION.OKTA;
          }
          try {
            const seamlessSession = await fetchSeamless(
              window.msizerConfiguration.seamlessToken,
              window.msizerConfiguration.seamlessEnv,
              window.msizerConfiguration.idpApp
            );

            if (implementation === AUTHENTIFICATION_IMPLEMENTATION.OKTA) {
              dispatch(setSeamlessSessionWithOkta(seamlessSession.data.payload));
            } else {
              dispatch(setSeamlessSession(seamlessSession.data));
            }
            dispatch(setSeamlessSessionIdFetched(true));
            return seamlessSession;
          } catch (error) {
            if (implementation === AUTHENTIFICATION_IMPLEMENTATION.OKTA) {
              console.log("Can't connect to Seamless session with okta");
            } else {
              console.log("Can't connect to Seamless session with ciam");
            }
            console.log(error);
            return undefined;
          }
        } else {
          dispatch(setSeamlessSessionIdFetched(true));
          return undefined;
        }
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execGetTechnologiesScope,
    isFetching: isFetchingGetTechnologiesScopeFromS3,
    isLoading: isLoadingGetTechnologiesScopeFromS3
  } = useQuery(
    "Get Technologies scope",
    async () => {
      try {
        const technologiesScope = await getTechnologiesScope();
        // console.log("technologiesScope", technologiesScope);
        dispatch(setTechnologiesScope(technologiesScope));
        return technologiesScope;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false,
      onSuccess: (data) => {
        // This function will be called after the query successfully fetches the data
        // console.log(data);
        openTechnologyIfNeeded(data);
      }
    }
  );

  const {
    refetch: execGetFiltersValues,
    isFetching: isFetchingGetFiltersFromS3,
    isLoading: isLoadingGetFiltersFromS3
  } = useQuery(
    "Get Filters values",
    async () => {
      try {
        const defaultFilters = await getFiltersValues();
        const cartesianDefaultFilters = await getCartesianFiltersValues();

        dispatch(setPossibleFiltersValues(defaultFilters));
        dispatch(setCartesianPossibleFiltersValues(cartesianDefaultFilters));
        dispatch(setIntegratedDrivesPossibleFiltersValues(defaultFilters));
        return defaultFilters;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const loadConfiguration = (config, readOnly = false) => {
    logEvent(eventsData.locale, eventsData.types.reOpen, eventsData.tags.fromEmail, config?.configId);
    switch (config.configData.configurationType) {
      case "RETROFIT":
        dispatch(setReadOnlyMode(readOnly || config.configData.configStatus === "FINISHED"));
        dispatch(setConfiguration(config));
        break;
      case "MC12":
        dispatch(setMc12Configuration(config));
        break;
      case "CARTESIAN":
        dispatch(setCartesianReadOnlyMode(readOnly || config.configData.configStatus === "FINISHED"));
        dispatch(setCartesianConfiguration(config));
        break;
      case "INTEGRATED_DRIVES":
        dispatch(setIntegratedDrivesConfiguration(config));
        break;
      default:
    }
    dispatch(setConfigurationType(config.configData.configurationType));
    dispatch(setFullScreen(true));
  };

  const [configurationIdToLoad] = useState(new URLSearchParams(window.location.search).get("configuration"));
  const [technologyToOpen] = useState(() => {
    const technologyParam = new URLSearchParams(window.location.search).get("technology");
    return technologyParam ? technologyParam.toUpperCase() : null;
  });
  const {
    refetch: execFetchConfigurationById,
    isFetching: isFetchingConfigurationById,
    isLoading: isLoadingGetConfigurationById
  } = useQuery(
    "Get saved configuration by ID",
    async () => {
      try {
        const fetchedConf = await getSavedConfigurationById({ id: configurationIdToLoad });
        loadConfiguration(fetchedConf.configuration, true);
        return fetchedConf;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configuration?.configId);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const loadConfigurationIfNeeded = async () => {
    if (configurationIdToLoad) {
      // load the configuration
      // console.log("Load", configurationIdToLoad);
      await execFetchConfigurationById();

      const url = new URL(window.location.href);
      url.searchParams.delete("configuration");
      window.history.replaceState(null, null, url);
    }
  };

  const { execSave, isLoadingStartConfiguration, isFetchingStartConfiguration } =
    useSaveConfiguration(technologyToOpen);

  const partnerPreferences = useSelector(selectPartnerPreferences);

  const partnerTechnologies = partnerPreferences?.availableTechnologies;

  const openTechnologyIfNeeded = async (technologiesScope) => {
    const availableTechnologies = Object.keys(technologiesScope?.technologies).filter((tech) => {
      const availableTechnology = technologiesScope?.technologies[tech].find(
        (availability) => availability.locale === locale
      );
      return availableTechnology;
    });
    if (
      technologyToOpen &&
      ["RETROFIT", "CARTESIAN", "MC12", "INTEGRATED_DRIVES"].includes(technologyToOpen) &&
      ((availableTechnologies && availableTechnologies.includes(technologyToOpen)) ||
        (partnerTechnologies && partnerTechnologies.includes(technologyToOpen)))
    ) {
      await execSave();
      dispatch(updateConfiguration());
    }
    const url = new URL(window.location.href);
    url.searchParams.delete("technology");
    window.history.replaceState(null, null, url);
  };

  const sessionIdFetched = useSelector(selectSessionIdFetched);
  const seamlessSessionIdFetched = useSelector(selectSeamlessSessionIdFetched);
  const minimalPopup = useSelector(selectMinimalPopup);

  const fullScreen = useSelector(selectFullScreen);

  const showContinueOnDesktopPopup = useSelector(selectShowContinueOnDesktopPopup);

  const [appIsReady, setAppIsReady] = useState(false);

  const [primaryColor, setPrimaryColor] = useState("#008a16");
  const [primaryTextColor, setPrimaryTextColor] = useState("#008a16");
  const [secondaryColor, setSecondaryColor] = useState("#0075A3");
  const [secondaryTextColor, setSecondaryTextColor] = useState("#FFFFFF");
  const [hoverPrimaryColor, setHoverPrimaryColor] = useState("#1faf3a");
  const [hoverPrimaryTextColor, setHoverPrimaryTextColor] = useState("#1faf3a");
  const [hoverSecondaryColor, setHoverSecondaryColor] = useState("#2496c8");
  const [hoverSecondaryTextColor, setHoverSecondaryTextColor] = useState("#FFFFFF");

  const exposeChangeLocaleFunction = () => {
    try {
      window.msizerConfiguration.setLocale = (locale) => {
        window.msizerConfiguration.locale = locale;
        // quit the current configuration if it's ongoing
        handleCancelConfiguration();
        dispatch(setLocale(locale));
        loadTranslation(locale);
      };
    } catch (e) {}
  };

  const exposeBeforeLogoutFunction = () => {
    try {
      window.msizerConfiguration.beforeLogout = () => {};
    } catch (e) {}
  };

  const widgetStartupHandler = async (event) => {
    if (!event.data) {
      return;
    }
    if (event.data.type === "ScWidgetStartupEvent") {
      console.debug("bootstrap: received ScWidgetStartupEvent, setting option in window element", event.data);

      const distrubutorColors = generateDistributorColors(
        event.data.options?.styling?.primary || "#008a16",
        event.data.options?.styling?.secondary || "#0075A3"
      );
      setPrimaryColor(distrubutorColors?.primaryColor);
      setPrimaryTextColor(distrubutorColors?.textColor);
      setSecondaryColor(distrubutorColors?.secondaryColor);
      setSecondaryTextColor(distrubutorColors?.secondaryTextColor);
      setHoverPrimaryColor(distrubutorColors?.hoverColor);
      setHoverPrimaryTextColor(distrubutorColors?.hoverTextColor);
      setHoverSecondaryColor(distrubutorColors?.secondaryHoverColor);
      setHoverSecondaryTextColor(distrubutorColors?.secondaryHoverTextColor);
      window.msizerConfiguration = event.data.options;
      window.msizerConfiguration.hostname = event.data.hostname;

      const lang = window.msizerConfiguration?.locale || "en-WW";
      dispatch(setLocale(lang));
      loadTranslation(lang);
      dispatch(setPartnerPreferences(event.data.options));
      exposeChangeLocaleFunction();
      exposeBeforeLogoutFunction();
      setAppIsReady(true);
      document.dispatchEvent(
        new CustomEvent("MSIZER_APP_READY", {
          bubbles: true
        })
      );
    }
  };

  useEffect(() => {
    if (window.top !== window.self) {
      window.addEventListener("message", widgetStartupHandler, false);
    } else {
      const lang = window.msizerConfiguration?.locale || "en-WW";
      dispatch(setLocale(lang));
      loadTranslation(lang);
      exposeChangeLocaleFunction();
      exposeBeforeLogoutFunction();
      setAppIsReady(true);
      document.dispatchEvent(
        new CustomEvent("MSIZER_APP_READY", {
          bubbles: true
        })
      );
    }
    // charger le captcha avec https://recaptcha.net/recaptcha/api.js
    execGetTechnologiesScope();
    execGetFiltersValues();
    execSession();
    execSeamlessSession();
    loadConfigurationIfNeeded();
  }, []);

  // console.log(process.env);

  return (
    appIsReady && (
      <PrintContextProvider data-testid="App">
        <style>
          :root{" "}
          {`{
            ${getRGBColor(primaryColor, "primary")} 
            ${getRGBColor(primaryTextColor, "primary-text-color")}

            ${getRGBColor(secondaryColor, "secondary")}
            ${getRGBColor(secondaryTextColor, "secondary-text-color")}

            ${getRGBColor(hoverPrimaryTextColor, "primary-hover-text-color")}
            ${getRGBColor(hoverSecondaryTextColor, "secondary-hover-text-color")}

            ${getRGBColor(hoverPrimaryColor, "hover-primary")} 
            ${getRGBColor(hoverSecondaryColor, "hover-secondary")}
          }`}
        </style>
        <div
          key={locale}
          className={`App msizer font-nunitoo motion-configurator-app bg-white md:shadow mb-2 overflow-hidden
      ${
        fullScreen
          ? "fixed top-0 left-0 bottom-0 right-0 overflow-auto z-fullScreen min-h-[100vh] max-h-[100vh] w-screen"
          : "relative min-h-[80vh] max-h-[80vh]"
      } ${
        isMobile &&
        currentStep !== (steps.retrofit.START || steps.cartesian.START || steps.mc12.START) &&
        currentStep !== steps.retrofit.SAVEANDSHARE
          ? "bg-gray-50"
          : "bg-white"
      }`}
        >
          {!sessionIdFetched ||
          !seamlessSessionIdFetched ||
          isFetchingGetTechnologiesScopeFromS3 ||
          isLoadingGetTechnologiesScopeFromS3 ||
          isFetchingGetFiltersFromS3 ||
          isLoadingGetFiltersFromS3 ||
          isFetchingConfigurationById ||
          isLoadingGetConfigurationById ||
          isLoadingStartConfiguration ||
          isFetchingStartConfiguration ? (
            <div className="my-10 text-center">
              <Spinner data-testid="spinner" />
            </div>
          ) : (
            <>
              <>
                <Header data-testid="header" />
                <div className="px-5 h-full w-full overflow-auto pb-20">{displayCurrentStep()}</div>
                {/* <LoginFooter /> */}
                {process.env.NODE_ENV === "development" && <ReactQueryDevtools />}
              </>
              <CustomPopup
                data-testid="custom-popup-message"
                text={minimalPopup.message}
                opened={minimalPopup.show}
                onClose={() => dispatch(closeMinimalPopup())}
                cancelAction={() => dispatch(closeMinimalPopup())}
                closeOnDocumentClick={false}
              />

              <CustomPopup
                data-testid="custom-popup-change-read-only-config"
                title={t("msizer.ui.popup.change_read_only_config.title")}
                text={t("msizer.ui.popup.change_read_only_config.text")}
                opened={showReadOnlyDialogPopup}
                onClose={() => {
                  configurationType === "CARTESIAN"
                    ? dispatch(setCartesianShowReadOnlyDialogPopup(false))
                    : dispatch(setShowReadOnlyDialogPopup(false));
                }}
                cancelLabel={t("msizer.ui.popup.change_read_only_config.cancel")}
                cancelAction={() => {
                  configurationType === "CARTESIAN"
                    ? dispatch(setCartesianShowReadOnlyDialogPopup(false))
                    : dispatch(setShowReadOnlyDialogPopup(false));
                }}
                continueLabel={t("msizer.ui.popup.change_read_only_config.continue")}
                continueAction={() => {
                  handleEditReadOnlyConfiguration();
                }}
                continueLoading={isLoading || isFetching}
              />

              <CustomPopup
                data-testid="custom-popup-cancel-configuration"
                title={t("msizer.ui.popup.cancel_configuration.title")}
                text={t("msizer.ui.popup.cancel_configuration.text")}
                opened={showCancelDialogPopup}
                onClose={() => dispatch(setShowCancelDialogPopup(false))}
                cancelLabel={t("msizer.ui.popup.button.return")}
                cancelAction={() => dispatch(setShowCancelDialogPopup(false))}
                continueLabel={t("msizer.ui.popup.button.confirm")}
                continueAction={() => {
                  handleCancelConfiguration();
                }}
                continueLoading={isFetchingCancelConfiguration || isLoadingCancelConfiguration}
              />

              {/* Continue on desktop popup */}
              <CustomPopup
                data-testid="custom-popup-continue-on-desktop"
                title={t("msizer.ui.popup.continue_on_desktop.title")}
                text={
                  currentStep === steps.retrofit.SAVEANDSHARE
                    ? // eslint-disable-next-line prettier/prettier
                      t("msizer.ui.popup.continue_on_desktop.finished_conf_text")
                    : // eslint-disable-next-line prettier/prettier
                      t("msizer.ui.popup.continue_on_desktop.not_finished_conf_text")
                }
                opened={showContinueOnDesktopPopup}
                onClose={() => {
                  dispatch(setShowContinueOnDesktopPopup(false));
                }}
                cancelAction={() => {
                  navigator.clipboard.writeText(configuration.configId);
                }}
                cancelLabel={t("msizer.ui.popup.continue_on_desktop.action")}
              />
              <CustomPopup
                data-testid="custom-popup-message-2"
                text={minimalPopup.message}
                opened={minimalPopup.show}
                onClose={() => dispatch(closeMinimalPopup())}
                cancelAction={() => dispatch(closeMinimalPopup())}
                closeOnDocumentClick={false}
              />
              <CustomPopup
                data-testid="custom-popup-change-read-only-config-2"
                title={t("msizer.ui.popup.change_read_only_config.title")}
                text={`${t("msizer.ui.popup.change_read_only_config.text")} ${
                  configuration?.configData?.country !== locale?.split("-")?.[1]
                    ? `Your locale (${locale?.split("-")?.[1]}) is different from the configuration locale (${
                        configuration?.configData?.country
                      }).`
                    : ""
                }`}
                opened={showReadOnlyDialogPopup}
                onClose={() => {
                  configurationType === "CARTESIAN"
                    ? dispatch(setCartesianShowReadOnlyDialogPopup(false))
                    : dispatch(setShowReadOnlyDialogPopup(false));
                }}
                cancelLabel={t("msizer.ui.popup.change_read_only_config.cancel")}
                cancelAction={() => {
                  configurationType === "CARTESIAN"
                    ? dispatch(setCartesianShowReadOnlyDialogPopup(false))
                    : dispatch(setShowReadOnlyDialogPopup(false));
                }}
                continueLabel={t("msizer.ui.popup.change_read_only_config.continue")}
                continueAction={() => {
                  handleEditReadOnlyConfiguration();
                }}
                continueLoading={isLoading || isFetching}
                closeOnDocumentClick={false}
              />
              <CustomPopup
                data-testid="custom-popup-cancel-configuration-2"
                title={t("msizer.ui.popup.cancel_configuration.title")}
                text={t("msizer.ui.popup.cancel_configuration.text")}
                opened={showCancelDialogPopup}
                onClose={() => dispatch(setShowCancelDialogPopup(false))}
                cancelLabel={t("msizer.ui.popup.button.return")}
                cancelAction={() => dispatch(setShowCancelDialogPopup(false))}
                continueLabel={t("msizer.ui.popup.button.confirm")}
                continueAction={() => {
                  handleCancelConfiguration();
                }}
                continueLoading={isFetchingCancelConfiguration || isLoadingCancelConfiguration}
              />
              <MobileBundleInfoPopup
                data-testid="mobile-popup-solution"
                solution={mobileBundleInfoPopup.solution}
                detailRef={mobileBundleInfoPopup.detailRef}
                opened={mobileBundleInfoPopup.show}
                onClose={() => dispatch(closeMobileBundleInfoPopup())}
              />

              {/* Continue on desktop popup */}
              <CustomPopup
                data-testid="custom-popup-continue-on-desktop-2"
                title={t("msizer.ui.popup.continue_on_desktop.title")}
                text={
                  currentStep === steps.retrofit.SAVEANDSHARE
                    ? // eslint-disable-next-line prettier/prettier
                      t("msizer.ui.popup.continue_on_desktop.finished_conf_text")
                    : // eslint-disable-next-line prettier/prettier
                      t("msizer.ui.popup.continue_on_desktop.not_finished_conf_text")
                }
                opened={showContinueOnDesktopPopup}
                onClose={() => {
                  dispatch(setShowContinueOnDesktopPopup(false));
                }}
                cancelAction={() => {
                  navigator.clipboard.writeText(configuration.configId);
                }}
                cancelLabel={t("msizer.ui.popup.continue_on_desktop.action")}
              />
            </>
          )}
        </div>
      </PrintContextProvider>
    )
  );
};

export default App;
